import { useMemo } from "react";

import { useModuleConfigurationSchema } from "@/features/integrations/hooks/useModuleConfiguration";
import type { UiComponent } from "@/features/integrations/types";
import { useAuth } from "@/lib/hooks/useAuth";

export type ChatDataProvider = {
  getClientViews(): UiComponent[];
};

export function useChatDataProvider(
  integrationName: string | undefined,
  clientId?: string | null,
): ChatDataProvider {
  const { tenantId } = useAuth();
  const normalizedName = integrationName?.toLowerCase() || "";

  const schemaQuery = useModuleConfigurationSchema(
    normalizedName,
    "chat",
    clientId
      ? {
        level: "client" as const,
        tenantId: tenantId ?? null,
        clientId,
      }
      : {
        level: "tenant" as const,
        tenantId: tenantId ?? null,
      },
    !!normalizedName,
  );

  return useMemo(() => {
    const ui: UiComponent[] = schemaQuery.data?.ui ?? [];
    return {
      getClientViews: () => ui,
    };
  }, [schemaQuery.data]);
}
